/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React from 'react';
import { JSErrorBoundary } from '@jira/platform__js-error-boundary/src/JSErrorBoundary.tsx';
import type { Nav4DragAndDropMenuItemProps } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/common/types.tsx';
import UFOSegment from '@atlassian/jira-ufo-segment/src/index.tsx';
import { CustomerExperiencesMenuItem } from './ui/CustomerExperiencesMenuItem.tsx';

interface Props extends Nav4DragAndDropMenuItemProps {}

export const CustomerService = (props: Props): React.JSX.Element => (
	<UFOSegment name="nav4-sidebar-customer-service">
		<JSErrorBoundary
			fallback="flag"
			id="assets"
			packageName="jiraNavigationAppsSidebarNav4SidebarsContentCustomerService"
			teamName="Boysenberry"
		>
			<CustomerExperiencesMenuItem {...props} />
		</JSErrorBoundary>
	</UFOSegment>
);
